export const getText = state => state.confirmModal.text;
export const getConfirmText = state => state.confirmModal.confirmText;
export const getCancelText = state => state.confirmModal.cancelText;
export const getOnConfirm = state => state.confirmModal.onConfirm;
export const getIsOpen = state => state.confirmModal.isOpen;
